const toCamelCase = (string) => {
    if (!string) {
        return
    }
    if (string.includes(' ')) {
        string = string.trim().replaceAll(' ', '')
    }

    return string[0].toLowerCase() + string.substring(1)
}

export default toCamelCase
